// src/main.js
import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from './axios'; // 引入 Axios 配置
import apiPlugin from './plugins/apiPlugin'; // 引入 API 插件
import router from './router';
import './style.css';  // 引入全局样式文件
import ApiService from './api/apiService';
Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(apiPlugin); // 注册 API 插件
Vue.use(ApiService); // 注册 API 插件
Vue.prototype.$axios = axios; // 将 Axios 实例添加到 Vue 原型

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');


export default {
  install(Vue) {
    Vue.prototype.$api = api;
  }
};